export const seniorTeam = [
    {
        name: "Subham Dutta",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706100656/avatars/WhatsApp_Image_2024-01-18_at_17.04.13_eus3wj.jpg",
        contribution: "Contributed in the Entire BackEnd and FrontEnd",
        email: "subhamdutta460@gmail.com",
        insta: "https://www.instagram.com/_________.subham/",
        linkedin: "https://www.linkedin.com/in/subhamdutta02/",
        github: "https://github.com/Subham-hyna"
    },
    {
        name: "Vikash Raj",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706099600/avatars/WhatsApp_Image_2024-01-24_at_18.03.05_xnuf0y.jpg",
        contribution: "Made the Mail Templates",
        email: "vikash21_ug@ee.nits.ac.in",
        insta: "https://www.instagram.com/vikashraj8126/",
        linkedin: "https://www.linkedin.com/in/vikash-raj-48b0b3244/",
        github: "https://GitHub.com/vikashcoder"
    }
]

export const juniorTeam = [
    {
        name: "Bhargob Lahon",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706099498/avatars/WhatsApp_Image_2024-01-24_at_18.01.18_xxmwwo.jpg",
        contribution: "Contributed in the IEI Teams and gallery Page",
        email: "lahonbhargab@gmail.com",
        insta: "https://www.instagram.com/lahon_bhargav?igsh=MWZhNHpkN2d3eDlxeA==",
        linkedin: "https://www.linkedin.com/in/bhargob-lahon-455527239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        github: "https://github.com/BhargobLahon"
    },
    {
        name: "Sarthak Jha",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706098890/avatars/IMG-20230902-WA0103_-_EE_023_SARTHAK_JHA_l10gro.jpg",
        contribution: "Contributed in the login-signup form prototype, and also made various changes in the frontend",
        email: "jhasarthak9@gmail.com",
        insta: "https://www.instagram.com/i_sarge_/",
        linkedin: "https://www.linkedin.com/in/sarthakjha2004?trk=universal-search-cluster",
        github: "https://github.com/SarJ2004"
    },
    {
        name: "Saumyabrat Borkotoky",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706099757/avatars/WhatsApp_Image_2024-01-24_at_18.05.44_epi31s.jpg",
        contribution: "Contributed specifically in footer",
        email: "saumyabratb_ug_22@ee.nits.sc.in",
        insta: "https://www.instagram.com/sam4space?igsh=MWZ4cHdtNnA5Y2QzMg==",
        linkedin: "https://www.linkedin.com/in/saumyabrat-borkotoky-ba1154255?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        github: "https://github.com/Saumyabrat978"
    },
    {
        name: "Kaushik Talukdar",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706099416/avatars/WhatsApp_Image_2024-01-24_at_17.59.58_oemi6j.jpg",
        contribution: "Contributed in the Signup Login Design",
        email: "kaushiktalukdar004@gmail.com",
        insta: "https://www.instagram.com/kaushik_talukdar04/",
        linkedin: "https://www.linkedin.com/in/kaushik-talukdar-8b7b86257/",
        github: "https://github.com/kaushikt-04"
    },
    {
        name: "Shwetangshu Biswas",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706097736/avatars/Screenshot_20240120-131449_-_EE_068_Shwetangshu_hifxsy.png",
        contribution: "Contributed in newsletter and GitHub repository creation",
        email: "shwetangshub_ug_22@ee.nits.ac.in",
        insta: "https://www.instagram.com/shwetangshub?igsh=NG84anIycXFkdW1l",
        linkedin: "https://www.linkedin.com/in/shwetangshu-biswas?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        github: "https://github.com/Shwetangshu"
    },
    {
        name: "Milan Sarmah",
        image_url: "https://res.cloudinary.com/dl71curl8/image/upload/v1706098675/avatars/IMG_20210207_103214_-_EE_065_MILAN_SARMAH_ajhswl.jpg",
        contribution: "Contributed in the Design of Gallery Page",
        email: "milans_ug_22@ee.nits.ac.in",
        insta: "",
        linkedin: "https://www.linkedin.com/in/milan-sarmah-b10aaa257/?originalSubdomain=in",
        github: "https://github.com/webdotmilans"
    },
]